import { ApplicationInsights } from '@microsoft/applicationinsights-web';

/** A simple reference to application insights */
export class AppInsightsRef {
  /** a single instance of application insights.  Do not set.  This will be set by module constructor. */
  appInsights?: ApplicationInsights;
}

